import { RadioList, TextInput } from "@milestone/component-library";
import React from "react";
import { Formik, FormikHelpers } from "formik";
import {
  BlueButton,
  ColumnContainer,
  OutlineButton,
  SaveButtonContainer,
  StyledForm,
} from "../../Admin.styles";
import {
  StatusOptions,
  CompanyFormType,
  CompanyFormSchema,
  CompanyFormHeader,
} from "./companyFormSchema";
import { Header, Section, TopSaveWrapper } from "../../topForm.styles";
import { useHistory } from "react-router-dom";

interface CompanyFormProps {
  header: string;
  submitValues: (
    values: CompanyFormType,
    actions: FormikHelpers<CompanyFormType>
  ) => void;
  value?: CompanyFormType;
  canSave?: boolean;
}

export const CompanyForm: React.FC<CompanyFormProps> = ({
  header,
  submitValues,
  value,
  canSave = true,
}) => {
  const defaultCompanyInfo: CompanyFormType = {
    status: StatusOptions[0],
    name: "",
    address: "",
    entityId: "",
  };

  if (value) {
    if (value.status) defaultCompanyInfo.status = value.status;
    if (value.name) defaultCompanyInfo.name = value.name;
    if (value.address) defaultCompanyInfo.address = value.address;
    if (value.entityId) defaultCompanyInfo.entityId = value.entityId;
  }

  const history = useHistory();

  const handleCancel = () => {
    const currentLocation = history.location;
    currentLocation.pathname = "/admin/companies";
    history.push(currentLocation);
  };

  const SaveButtons = (
    <SaveButtonContainer>
      <BlueButton type={canSave ? "submit" : "button"}>Save</BlueButton>
      <OutlineButton type="button" onClick={handleCancel}>
        Cancel
      </OutlineButton>
    </SaveButtonContainer>
  );

  return (
    <ColumnContainer>
      <Formik
        initialValues={defaultCompanyInfo}
        validationSchema={CompanyFormSchema}
        onSubmit={submitValues}
      >
        {() => (
          <StyledForm>
            <TopSaveWrapper>{SaveButtons}</TopSaveWrapper>
            <Header>{header}</Header>

            <Section>
              {header !== CompanyFormHeader.add && (
                <div>
                  <RadioList
                    label="Status"
                    name="status"
                    options={StatusOptions}
                  />
                </div>
              )}

              <TextInput
                name="name"
                label="Company Name"
                placeholder="Company Name"
              />
              <TextInput name="address" label="Address" placeholder="Address" />
              <TextInput
                name="entityId"
                label="Entity Id"
                placeholder="Entity Id"
              />
            </Section>
            {/*errors && <div>{JSON.stringify(errors)}</div>*/}
          </StyledForm>
        )}
      </Formik>
    </ColumnContainer>
  );
};
